// api.js

import axiosInstance from "../axiosInstance";

export const transactionService = {
  create: async (obj) => {
    try {
      let response = await axiosInstance.post("/paypal-transaction", obj);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  get: async (id) => {
    try {
      let response = await axiosInstance.get(`/transaction/${id}`);
      return response.data;
    } catch (e) {
      console.error(e);
    }
  },
  fetch: async (limit, skip) => {
    try {
      let response = await axiosInstance.get(
        `/transaction?$sort[createdAt]=-1&$limit=${limit || 15}&$skip=${
          skip || 0
        }
          `
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
